import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { policystreamStore } from '../store/policystreamStore';
const {
  actions: { setSaveButtonVisibility },
} = policystreamStore;

export const useSetPolicyStreamSaveButtonVisibility = (visibility: boolean) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setSaveButtonVisibility(visibility));
  }, [visibility]);
};
